import t from "./ClearIndicator.js";
import r from "./Input.js";
import i from "./LoadingIndicator.js";
import n from "./Option.js";
const e = (o) => ({
  LoadingIndicator: i,
  ClearIndicator: t(o),
  Option: n(o),
  Input: r
});
export {
  e as default
};
